import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MaterialModule } from '../../../shared/material.module';
import { EditPyramidItemComponent } from "../edit-pyramid-item/edit-pyramid-item.component";
import { PyramidDto } from '../../../models/api/pyramidDto';
import { PyramidEntriesByYearDto } from '../../../models/api/pyramidEntriesByYearDto';

export interface EditPyramidDialogData {
  pyramidItem: PyramidDto;
  largeShareholderId: string;
  pyramidEntriesByYear?: PyramidEntriesByYearDto;
}

@Component({
  selector: 'app-edit-pyramid-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MaterialModule,
    EditPyramidItemComponent
  ],
  templateUrl: './edit-pyramid-dialog.component.html',
  styleUrls: ['./edit-pyramid-dialog.component.scss']
})
export class EditPyramidDialogComponent implements OnInit {
  @ViewChild(EditPyramidItemComponent) editPyramidItemComponent!: EditPyramidItemComponent;

  isFormValid: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditPyramidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditPyramidDialogData,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {}

  onConfirm(): void {
    this.editPyramidItemComponent.onConfirm();
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onFormValidityChange(isValid: boolean) {
    // Use setTimeout to defer the update to the next change detection cycle
    setTimeout(() => {
      this.isFormValid = isValid;
      this.cdr.markForCheck();
    });
  }
}
